<template>
  <div class="unapproved">
    <v-container>
      <v-row>
        <v-col
          ><h2 class="main-color text-center mb-4">
            {{ $t("Unapproved Products") }}
          </h2></v-col
        >
      </v-row>
      <v-card v-for="(item, index) in rejectedProducts" :key="index">
        <v-row class="product-item">
          <v-col cols="12" sm="2">
            <v-img
              :src="item.thumb"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="50px"
            >
            </v-img>
          </v-col>
          <v-col cols="12" sm="2">
            <p class=" main-color">
              <strong>{{ item.name }} </strong>
            </p>
          </v-col>
          <v-col cols="12" sm="8">
            <p class="grey--text darken">
              {{ item.rejection_reason }}
            </p>
          </v-col>
        </v-row>
      </v-card>

      <v-row>
        <v-col>
          <div class="text-center">
            <v-pagination
              v-model="page"
              color="#13a8b1"
              :length="total"
              v-if="total > 1"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "UnapprovedProduct",
  data() {
    return {
      rejectedProducts: [],
      page: 1,
      total: 6
    };
  },
  methods: {
    getRejectedProducts() {
      this.$http
        .get(this.getApiUrl + "/seller/product/rejected", {
          headers: {
            Authorization: "Bearer " + localStorage.seller_token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.rejectedProducts = response.data.data.data;
            this.page = response.data.data.current_page;
            this.total = response.data.data.last_page;
          }
        });
    }
  },
  mounted() {
    this.getRejectedProducts();
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.v-card {
  padding: 1rem !important;
  margin-bottom: 1rem !important;
}
</style>
